export default function SuitableFor() {
  const suitableTypes = [
    {
      icon: 'ri-percent-line',
      title: '高還元率を重視する方',
      description: '年会費無料で常に1.2%の高還元率。ポイント還元率を最優先に考える方に最適です。',
      color: 'from-orange-500 to-red-500'
    },
    {
      icon: 'ri-restaurant-line',
      title: '外食・旅行が多い方',
      description: '提携の飲食店予約サービスや宿泊予約サービスで最大4.2%還元。外食や旅行をよくする方におすすめです。',
      color: 'from-red-500 to-pink-500'
    },
    {
      icon: 'ri-smartphone-line',
      title: '電子マネーを使う方',
      description: '楽天Edy、モバイルSuicaへのチャージでも1.2%還元。電子マネーを日常的に使う方に向いています。',
      color: 'from-orange-500 to-amber-500'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '年会費を払いたくない方',
      description: '年会費永年無料で高還元率を実現。維持費をかけずにお得にポイントを貯めたい方にぴったりです。',
      color: 'from-amber-500 to-yellow-500'
    }
  ];

  const unsuitableTypes = [
    {
      icon: 'ri-store-line',
      title: '特定店舗での優待を重視する方',
      description: '百貨店やショッピングモールでの特別優待は少なめ。特定店舗でのお得さを求める方には向いていません。'
    },
    {
      icon: 'ri-bank-card-line',
      title: 'ポイントを直接使いたい方',
      description: 'ポイントを使うには交換手続きが必要。カード利用代金に直接充当したい方には不向きです。'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-orange-50 via-white to-red-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-4">
            こんな方におすすめ
          </h2>
          <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
            高還元率カードが特に向いているのはこんな方です
          </p>
          <div className="grid md:grid-cols-2 gap-6">
            {suitableTypes.map((type, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
              >
                <div className={`w-14 h-14 bg-gradient-to-br ${type.color} rounded-xl flex items-center justify-center mb-4`}>
                  <i className={`${type.icon} text-white text-2xl w-6 h-6 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {type.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {type.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-4">
            向いていない方
          </h2>
          <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
            以下のような方は他のカードも検討してみてください
          </p>
          <div className="grid md:grid-cols-2 gap-6">
            {unsuitableTypes.map((type, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-lg border border-gray-200"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${type.icon} text-gray-600 text-xl w-6 h-6 flex items-center justify-center`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">
                      {type.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {type.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">
            高還元率を求めるなら最適な選択
          </h3>
          <p className="text-lg mb-6 opacity-90">
            年会費無料で業界最高水準の1.2%還元率。<br className="hidden md:block" />
            ポイント重視の方には間違いなくおすすめのカードです。
          </p>
          <a
            href="https://px.a8.net/svt/ejp?a8mat=4AXB0E+3PYKNU+4T5W+5YRHE"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-block bg-white text-orange-600 font-bold text-lg px-10 py-4 rounded-xl hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            公式サイトで詳細を見る
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
